function _objectDestructuringEmpty(obj) {
  if (obj == null) throw new TypeError("Cannot destructure undefined");
}
/**
 * @fileOverview Cross
 */


function Cell(_ref) {
  _objectDestructuringEmpty(_ref);

  return null;
}

Cell.displayName = 'Cell';
export default Cell;